// AddContactForm.js
import React from 'react';

const AddContactForm = ({ formData, handleInputChange, handleSubmit, resetForm, setShowAddModal, isLoading }) => {
  
  return (
     <div className="bg-white rounded-lg p-6 w-full max-w-2xl shadow-2xl">
            {/* Header with gradient background */}
            <div className="flex justify-between items-center mb-6 pb-3 border-b">
              <h2 className="text-xl font-semibold text-gray-800">Add New Contact</h2>
              <button 
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                className="text-white bg-red-600 hover:bg-red-800 p-1 rounded-lg transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Two-column layout for smaller fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Name Field */}
                <div>
                  <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="name">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                    required
                  />
                </div>
                
                {/* Email Field */}
                <div>
                  <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="email">
                    Email 
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  />
                </div>
              </div>
              
            {/* Phone Number and User Type Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Phone Number Field */}
              <div>
                <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="phone">
                  Phone Number 
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                />
              </div>
              
              {/* User Type Field */}
              <div>
                <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="userType">
                  User Type <span className="text-red-500">*</span>
                </label>
                <select
                  id="userType"
                  name="userType"
                  value={formData.userType}
                  onChange={handleInputChange}
                  className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-0 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  required
                >
                  <option value="">--Select User Type--</option>
                  <option value="Enterprise">ENTERPRISE</option>
                  <option value="Vendor">VENDOR</option>
                  <option value="FlexpertEnquiry">FLEXPERT ENQUIRY</option>
                </select>
              </div>
            </div>
              
              {/* Company Name Field */}
              <div>
                <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="companyName">
                  Company Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                />
              </div>
              
              {/* Two-column layout for more fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Title Field */}
                <div>
                  <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="title">
                    Title
                  </label>
                  <input
                    type="text"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="e.g. Developer, Manager"
                    className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  />
                </div>
                
                {/* Location Field */}
                <div>
                  <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="location">
                    Location
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="e.g. Noida, Delhi"
                    className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  />
                </div>
              </div>
              
              {/* Last row of fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Source Field */}
                <div>
                  <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="source">
                    Source
                  </label>
                  <select
                    id="source"
                    name="source"
                    value={formData.source}
                    onChange={handleInputChange}
                    className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-0 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  >
                    <option value="">--Select Source--</option>
                    <option value="linkedIn">LinkedIn</option>
                    <option value="website">Website</option>
                    <option value="referral">Referral</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                {/* Lead Status Field */}
               <div>
                <label className="block text-gray-800 text-sm font-semibold mb-1" htmlFor="leadStatus">
                  Lead Status
                </label>
                <select
                  id="leadStatus"
                  name="leadStatus"
                  value={formData.leadStatus}
                  onChange={handleInputChange}
                  className="shadow-sm border border-gray-300 rounded-md w-full py-2 px-0 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                >
                  <option value="">--Select Status--</option>
                  <option value="new">New</option>
                  <option value="attempted_contact">Attempted Contact</option>
                  <option value="follow_up_scheduled">Follow-up Scheduled</option>
                  <option value="interested">Interested</option>
                  <option value="not_interested">Not Interested</option>
                  <option value="wrong_contact">Wrong Contact</option>
                  <option value="converted_to_lead">Converted to Lead</option>
                </select>
                </div>
                </div>
              
              {/* Form Actions */}
              <div className="flex items-center justify-end pt-4 border-t mt-6">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded mr-2 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading}
                  className="bg-[#3985b6] hover:bg-[#2b6a94] text-white font-medium py-2 px-4 rounded focus:outline-none focus:shadow-outline transition-colors duration-200"
                >
                  {isLoading ? 'Adding...' : 'Add Contact'}
                </button>
              </div>
            </form>
          </div>
  );
};

export default AddContactForm;
